import React from 'react';
import Section from './Section';
import CurrencyDollarIcon from './icons/CurrencyDollarIcon';

const PricingSection: React.FC = () => {
  return (
    <Section id="pricing" title="Affordable Pricing" className="bg-white">
      <div className="max-w-3xl mx-auto text-center">
        <CurrencyDollarIcon className="w-16 h-16 text-emerald-500 mx-auto mb-6" />
        <p className="text-xl text-gray-700 mb-4">
          Each roll contains <strong className="text-emerald-600">1,000 high-quality labels</strong> and costs just <strong className="text-emerald-600">$49.00 per roll</strong>, offering an exceptional return on investment.
        </p>
        <p className="text-xl text-gray-700 mb-8">
          The minimum purchase is only <strong className="text-emerald-600">one roll</strong>, making it easy to get started and see the benefits for yourself.
        </p>
        <a
          href="#contact"
          className="inline-block px-6 py-2.5 sm:px-8 sm:py-3 text-base sm:text-lg bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-lg transition duration-300 ease-in-out transform hover:scale-105 shadow-lg"
        >
          Get a Quote or Order Now
        </a>
      </div>
    </Section>
  );
};

export default PricingSection;
